import React from 'react'
import SoftwareBanner from '../Components/software/SoftwareBanner'
import Softwares from '../Components/software/Softwares'

const Software = () => {
    return (
        <div>
            <SoftwareBanner />
            <Softwares />
        </div>
    )
}

export default Software
